import { useState } from "react";
import { Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../../components/ui/dialog";
import { api, apiError } from "../../lib/api";
import { useAuth } from "../../store/AuthContext";
import { TermsBody, TERMS_VERSION } from "./TermsDialog";

export const needsTerms = (user) => Boolean(user) && user.role !== "admin" && user.terms_version !== TERMS_VERSION;

export const TermsGate = () => {
  const { refresh } = useAuth();
  const [agree, setAgree] = useState(false);
  const [busy, setBusy] = useState(false);
  const accept = async () => {
    setBusy(true);
    try { await api.acceptTerms(); await refresh(); toast.success("Thanks — terms accepted"); } catch (e) { toast.error(apiError(e)); setBusy(false); }
  };
  return (
    <Dialog open>
      <DialogContent className="glass-panel max-w-2xl [&>button]:hidden" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()} data-testid="terms-gate">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-[15px]"><ShieldCheck className="h-4 w-4 text-[#3ecf8e]" /> Updated Terms of Use &amp; Template License</DialogTitle>
          <DialogDescription className="text-[#9aa0a8]">Version {TERMS_VERSION}. Please review and accept once to keep using Xpattern — the templates in your workspace are proprietary and licensed to your shop only.</DialogDescription>
        </DialogHeader>
        <div className="scroll-visible max-h-[48vh] overflow-y-auto pr-2"><TermsBody compact /></div>
        <label className="flex items-start gap-2.5 rounded-md border border-white/10 bg-white/[0.03] px-3 py-2 text-[12px] leading-snug text-[#c9ccd2]">
          <input data-testid="terms-gate-checkbox" type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} className="mt-0.5 h-3.5 w-3.5 flex-none accent-[#2f80ff]" />
          <span>I have read and agree to the Terms of Use &amp; Template License. I will not copy, share, export or redistribute Xpattern templates.</span>
        </label>
        <div><button data-testid="terms-gate-accept" disabled={!agree || busy} onClick={accept} className="glass-cta flex w-full items-center justify-center gap-2 py-2 text-[13px] font-semibold disabled:opacity-50" style={{ "--glass-accent": "#3ecf8e" }}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ShieldCheck className="h-4 w-4" />} I accept
        </button></div>
      </DialogContent>
    </Dialog>
  );
};
